import { User, Store } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { FileImage } from "@/components/files/FileFields";
import { round2 } from "@/lib/format";
import { Box, Clock, TKey, TKeypad } from "@/components/terminal/TKeys";

export default function StartScreen({ term, tk, buf, onKey, act }) {
  const { t, view, staff, lang, money } = useApp();
  const date = new Date().toLocaleDateString(lang === "es" ? "es-ES" : lang === "fr" ? "fr-FR" : "ar-u-nu-latn", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).replace(/\u200f/g, "");
  return (
    <div className="grid lg:grid-cols-[minmax(0,1fr)_344px] gap-1 lg:h-full" data-testid="tm-start-screen">
      <div className="flex flex-col gap-1 min-w-0">
        <div className="grid grid-cols-3 sm:grid-cols-[230px_repeat(5,minmax(0,1fr))] gap-1">
          <button type="button" onClick={act.pickTerm} className="col-span-3 sm:col-span-1 flex flex-col gap-1 text-start" data-testid="tm-terminal-box">
            <Box className="text-center w-full" testid="tm-terminal-name">{term?.name}</Box>
            <Box className="text-center w-full uppercase" testid="tm-date">{date} [1]</Box>
          </button>
          <TKey onClick={act.customer} testid="tm-start-customer">{t("tm_customer_id")}</TKey>
          <TKey onClick={act.newSale} testid="tm-start-account">{t("tm_account")}</TKey>
          <TKey onClick={act.lastTicket} testid="tm-start-ticket">{t("tm_ticket")}</TKey>
          <TKey onClick={act.article} testid="tm-start-article">{t("tm_article")}</TKey>
          <TKey onClick={act.lock} testid="tm-start-lock">{t("tm_lock")}</TKey>
        </div>
        <div className="flex-1 min-h-[160px] grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] auto-rows-[86px] gap-1 content-start p-1" data-testid="tm-start-accounts">
          {tk.held.map((h) => (
            <TKey key={h.id} tone="peach" onClick={() => act.recall(h)} testid="tm-start-held">
              <span>{h.label}<span className="block font-normal normal-case" dir="ltr">{money(round2(h.cart.reduce((s, l) => s + l.price * l.qty, 0)))}</span></span>
            </TKey>
          ))}
        </div>
        <div className="grid grid-cols-5 gap-1">
          <TKey onClick={act.accounts} testid="tm-start-accounts-btn">{t("tm_accounts")} ({tk.held.length})</TKey>
          <TKey onClick={act.funds} testid="tm-start-funds">{t("tm_funds")}</TKey>
          <TKey onClick={act.services} testid="tm-start-services">{t("tm_services")}</TKey>
          <TKey onClick={act.arqueo} testid="tm-start-arqueo">{t("tm_arqueo")}</TKey>
          <TKey onClick={act.drawer} testid="tm-start-drawer">{t("open_drawer")}</TKey>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="grid grid-cols-[1fr_84px] gap-1">
          <div className="space-y-1">
            <div className="flex items-center gap-2"><Box className="flex-1 truncate" testid="tm-shop-name">{view.shop?.name}</Box><Clock /></div>
            <div className="flex items-center gap-2 px-2 text-[13px] font-bold text-[#3A6EA5]" data-testid="tm-staff-name"><User className="w-4 h-4" />{staff?.name}</div>
          </div>
          <TKey onClick={act.exit} testid="tm-start-exit">{t("tm_exit")}</TKey>
        </div>
        <div className="flex-1 min-h-[200px] bg-white grid place-items-center p-4" data-testid="tm-logo">
          {view.shop?.logo_id ? <FileImage id={view.shop.logo_id} className="max-h-[260px] max-w-full object-contain" /> : (
            <div className="text-center text-[#1E1A17]"><Store className="w-20 h-20 mx-auto" strokeWidth={1} /><div className="mt-2 text-2xl tracking-[0.2em] uppercase font-serif">{view.shop?.name}</div></div>
          )}
        </div>
        <Box className="text-end h-8 text-lg" testid="tm-start-buffer"><span dir="ltr">{buf || " "}</span></Box>
        <TKeypad onKey={onKey} labels={{ clear: t("tm_clear"), enter: t("tm_enter") }} />
      </div>
    </div>
  );
}
